import { jsx as t, Fragment as T, jsxs as d } from "react/jsx-runtime";
import e from "./styles.module.less.js";
import { useMemo as h, useState as f, useRef as g } from "react";
import { useOnClickOutside as I } from "../../../../utils/on-click-outside.js";
import k from "../folder.svg.js";
import N from "../settings.svg.js";
import v from "../logout.svg.js";
import { useScreenSize as M, WidthType as C } from "../../../../utils/use-is-mobile.js";
import { MenuItem as O } from "../menu-item/index.js";
import { UserImage as S } from "./user-image.js";
import { MobileMenuDropdown as b } from "../mobile-menu-dropdown/index.js";
const G = (m) => {
  const {
    userImage: s,
    logout: i,
    hasNotifications: c,
    isActive: p,
    isScrolledHeader: a,
    getTranslation: o,
    closeMenuModal: l
  } = m, r = M(), u = h(() => r === C.Mobile, [r]), n = h(
    () => [
      // {
      //   title: getTranslation('account.new-case'),
      //   icon: (
      //     <div className={styles.newCaseWrapper}>
      //       <div className={styles.newCaseIconPosition}>
      //         <PlusIcon className={styles.newCaseIcon} />
      //       </div>
      //       <div className={styles.newCaseIconPosition}>
      //         <img src={PlusIconHover} className={styles.newCaseIconHover} />
      //       </div>
      //     </div>
      //   ),
      //   path: '/chat?newCase=true',
      //   isGradient: true,
      // },
      {
        title: o("account.my-cases"),
        icon: /* @__PURE__ */ t(k, { className: e.menuIcon }),
        path: "/account"
      },
      {
        title: o("account.settings"),
        icon: /* @__PURE__ */ t(N, { className: e.menuIcon }),
        path: "/account/edit"
      },
      {
        title: o("account.sign-out"),
        icon: /* @__PURE__ */ t(v, { className: e.menuIcon }),
        onClick: i
      }
    ],
    [o, i]
  );
  return u ? /* @__PURE__ */ t(
    x,
    {
      userImage: s,
      hasNotifications: c,
      getTranslation: o,
      logout: i,
      closeMenuModal: l
    }
  ) : /* @__PURE__ */ t(
    y,
    {
      isScrolledHeader: a,
      isActive: p,
      userImage: s,
      hasNotifications: c,
      menuItems: n,
      getTranslation: o
    }
  );
}, x = (m) => {
  const {
    userImage: s,
    hasNotifications: i,
    getTranslation: c,
    logout: p,
    closeMenuModal: a
  } = m, [o, l] = f(!1), r = g(null), u = () => {
    l(!o), a == null || a();
  };
  return I(r, () => l(!1)), /* @__PURE__ */ t(
    b,
    {
      items: [
        {
          title: c("account.my-cases"),
          link: "/account",
          icon: k
        },
        {
          title: c("account.settings"),
          link: "/account/edit",
          icon: N
        },
        {
          title: c("account.sign-out"),
          onClick: p,
          icon: v
        }
      ],
      toggleOpen: u,
      isOpen: o,
      menuWrapperRef: r,
      children: /* @__PURE__ */ t(S, { userImage: s, hasNotifications: i })
    }
  );
}, y = (m) => {
  const {
    isScrolledHeader: s,
    isActive: i,
    userImage: c,
    hasNotifications: p,
    menuItems: a,
    getTranslation: o
  } = m, [l, r] = f(!1), u = g(null);
  return I(u, () => r(!1)), /* @__PURE__ */ t("div", { className: e.menuWrapper, ref: u, children: /* @__PURE__ */ t(
    O,
    {
      label: o("pages.account"),
      chevronStyle: "rotate",
      hasShrunk: s,
      isActive: i,
      classNames: {
        wrapper: e.accountLinkWrapper,
        childContainer: `${e.hoverMenu} ${s ? e.scrolledHeader : ""} ${l ? e.forceOpen : ""}`,
        labelTitle: e.accountLabelTitle,
        chevronIcon: e.chevronIcon
      },
      icon: /* @__PURE__ */ t(
        S,
        {
          userImage: c,
          hasNotifications: p
        }
      ),
      path: "/account",
      children: /* @__PURE__ */ t(T, { children: a.map(
        (n) => n.path ? /* @__PURE__ */ d("a", { href: n.path, className: e.menuItem, children: [
          /* @__PURE__ */ t(
            "span",
            {
              className: `${e.menuItemText} ${n.isGradient ? e.gradientText : ""}`,
              children: n.title
            }
          ),
          n.icon
        ] }, n.title) : n.onClick ? /* @__PURE__ */ d(
          "div",
          {
            onClick: n.onClick,
            className: e.menuItem,
            children: [
              /* @__PURE__ */ t("span", { className: e.menuItemText, children: n.title }),
              n.icon
            ]
          },
          n.title
        ) : null
      ) })
    }
  ) });
};
export {
  G as AuthenticatedAccountLink
};
